/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { type TFunction } from 'i18next'
import { type StatusBadgeProps } from '@/components/status-badge'

export const REGISTER_CODE_STATUS = {
  UNUSED: 1,
  USED: 0,
} as const

export const REGISTER_CODE_STATUS_VALUES = Object.values(
  REGISTER_CODE_STATUS
).map((value) => String(value)) as `${number}`[]

export const REGISTER_CODE_STATUSES: Record<
  number,
  Pick<StatusBadgeProps, 'variant' | 'showDot'> & {
    labelKey: string
    value: number
  }
> = {
  [REGISTER_CODE_STATUS.UNUSED]: {
    labelKey: '未使用',
    variant: 'success',
    value: REGISTER_CODE_STATUS.UNUSED,
    showDot: true,
  },
  [REGISTER_CODE_STATUS.USED]: {
    labelKey: '已使用',
    variant: 'neutral',
    value: REGISTER_CODE_STATUS.USED,
    showDot: true,
  },
} as const

export function getRegisterCodeStatusOptions(t: TFunction) {
  return Object.values(REGISTER_CODE_STATUSES).map((config) => ({
    label: t(config.labelKey),
    value: String(config.value),
  }))
}

export const REGISTER_CODE_VALIDATION = {
  COUNT_MIN: 1,
  COUNT_MAX: 100,
} as const

export const ERROR_MESSAGES = {
  LOAD_FAILED: '加载注册码失败',
  SEARCH_FAILED: '搜索注册码失败',
  CREATE_FAILED: '创建注册码失败',
  DELETE_FAILED: '删除注册码失败',
  COUNT_INVALID: '数量必须在 {{min}} 到 {{max}} 之间',
} as const

export function getRegisterCodeFormErrorMessages(t: TFunction) {
  return {
    COUNT_INVALID: t(ERROR_MESSAGES.COUNT_INVALID, {
      min: REGISTER_CODE_VALIDATION.COUNT_MIN,
      max: REGISTER_CODE_VALIDATION.COUNT_MAX,
    }),
  } as const
}

export const SUCCESS_MESSAGES = {
  REGISTER_CODE_CREATED: '注册码创建成功',
  REGISTER_CODE_DELETED: '注册码已删除',
} as const
